/**
 * 行业资讯目录编码
 */
export enum NewsCatalogueCode {
  /**
   * 行业新闻
   */
  TRADE_NEWS = 'TRADE_NEWS',

  /**
   * 行业价格
   */
  TRADE_PRICE = 'TRADE_PRICE',

  /**
   * 独家分析
   */
  EXCLUSIVE_ANALYSIS = 'EXCLUSIVE_ANALYSIS',

  /**
   * 数据统计
   */
  DATA_STATISTICS = 'DATA_STATISTICS'
}

export const NewsCatalogueCodeTextMap = {
  [NewsCatalogueCode.TRADE_NEWS]: '行业新闻',
  [NewsCatalogueCode.TRADE_PRICE]: '行业价格',
  [NewsCatalogueCode.EXCLUSIVE_ANALYSIS]: '独家分析',
  [NewsCatalogueCode.DATA_STATISTICS]: '数据统计'
}
